import type { CtaBlockProps } from '../types';
import { theme, sectionColors } from '../theme';

/** Pure call-to-action band. */
export function CtaBlock(props: CtaBlockProps) {
  const { heading, body, buttonLabel, buttonHref } = props;
  // Readable on-color for the primary band — so the CTA heading/body stay legible on a LIGHT brand
  // primary (the same invisible-white-text bug the footer had). The button below is a white chip
  // with its own fixed dark-ish label, so it's unaffected.
  const colors = sectionColors(props, { bg: theme.primary, text: theme.onPrimary });
  return (
    <section className="px-6 py-16 text-center" style={{ ...colors, fontFamily: theme.bodyFont }}>
      <h2 className="text-3xl font-semibold" style={{ fontFamily: theme.headingFont }}>{heading}</h2>
      {body ? <p className="mx-auto mt-3 max-w-xl opacity-80">{body}</p> : null}
      {/* White button with a fixed dark, always-readable label — stays legible
          whatever the band's backgroundColor is (avoids white-on-white). */}
      <a href={buttonHref} className="mt-8 inline-block rounded-md bg-white px-6 py-3 font-medium hover:opacity-90" style={{ color: theme.primary }}>
        {buttonLabel}
      </a>
    </section>
  );
}
